import React from 'react';

const Context = React.createContext<any>({});

export const Provider = ({ children }) => {
    const [state, setState] = React.useState({});
    const value = {
        state,
        setState: (url, updater) =>
            setState(currentState => ({
                ...currentState,
                [url]: updater(currentState[url]),
            })),
    };

    return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const Consumer = Context.Consumer;

export default Context;
